import { useState, useRef, useEffect } from "react";
import { Pencil, X } from "lucide-react";

const RoleCard = ({ role, count, permissions }) => {
  const maxVisible = 4;
  const visiblePermissions = permissions.slice(0, maxVisible);
  const hiddenPermissions = permissions.slice(maxVisible);
  const hiddenCount = hiddenPermissions.length;

  const [showPopover, setShowPopover] = useState(false);
  const popoverRef = useRef(null);

  // Close popover when clicked outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setShowPopover(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 relative hover:shadow-md transition-shadow duration-200">
      {/* Header */}
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-base font-semibold text-gray-800">{role}</h3>
        <span className="text-xs bg-gray-100 text-gray-700 rounded-full px-2 py-1">
          {count}
        </span>
      </div>

      {/* Permissions */}
      <div className="mb-6 relative">
        <p className="text-sm text-gray-500 mb-2">Permissions:</p>
        <div className="flex flex-wrap gap-2">
          {visiblePermissions.map((perm, idx) => (
            <span
              key={idx}
              className="text-xs font-medium bg-amber-50 text-gray-700 rounded-full px-3 py-1 border border-amber-100"
            >
              {perm}
            </span>
          ))}

          {hiddenCount > 0 && (
            <button
              onClick={() => setShowPopover(!showPopover)}
              className="text-xs font-medium bg-gray-100 text-gray-600 rounded-full px-3 py-1 border border-gray-200 cursor-pointer hover:bg-gray-200 transition"
            >
              +{hiddenCount}
            </button>
          )}
        </div>

        {/* Popover */}
        {showPopover && (
          <div
            ref={popoverRef}
            className="absolute top-full left-0 mt-2 bg-white border border-gray-200 rounded-xl shadow-lg p-3 w-56 z-20 animate-fadeIn"
          >
            <div className="flex justify-between items-center mb-2">
              <span className="text-xs font-semibold text-gray-700">
                Additional Permissions
              </span>
              <button
                onClick={() => setShowPopover(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X size={14} />
              </button>
            </div>
            <div className="flex flex-wrap gap-2">
              {hiddenPermissions.map((perm, idx) => (
                <span
                  key={idx}
                  className="text-xs font-medium bg-amber-50 text-gray-700 rounded-full px-3 py-1 border border-amber-100"
                >
                  {perm}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Edit Button */}
      <button className="absolute bottom-4 right-4 bg-gray-50 hover:bg-gray-100 p-2 rounded-full border border-gray-200 text-gray-500 hover:text-gray-700 transition">
        <Pencil size={16} />
      </button>
    </div>
  );
};

export default RoleCard;
